
<br><br><br><br><br><br>
<div class="container mt-4" style="padding-top:70px; padding-bottom: 400px;">
    <div class="row">
        <div class="col-sm-8" >
          <mdb-card class="card-header">           
                <mdb-card-body>
                        <ng-stepper #cdkStepper [linear]="true">
                            <cdk-step #cdkStepOne>
                              <ng-template cdkStepLabel>
                                <div class="step-bullet">1</div>
                                <div class="step-title">Información de envío<span class="required"></span></div>
                              </ng-template>
                              <app-informacion-envio
                                [cdkStepOne]="cdkStepOne"
                                [cdkStepper]="cdkStepper"
                                (enviarOrderRequest)="recibirOrder($event)"
                                (enviarPadreEvent)="recibirMensajeHijoInf($event)"
                                (abrirModalTerminosEvent)="abrirModalTerminos()"
                                (cerrarModalTerminosEvent)="cerrarModalTerminos()"
                                (aceptarTerminosEvent)="aceptarTerminos()"
                                #stepOne>
                              </app-informacion-envio>
                            </cdk-step>
                            
                            <cdk-step completed="false">
                              <ng-template cdkStepLabel style="pointer-events: none !important;">
                                <div class="step-bullet">2</div>
                                <div class="step-title">Medio de Pago</div>
                              </ng-template>
                              <app-medio-pago [cdkStepOne] = "cdkStepOne" [cdkStepper] = "cdkStepper" [orderRequest]="orderRequestInfoEnvio" #stepTwo></app-medio-pago>
                            </cdk-step>    
                         </ng-stepper>
                        </mdb-card-body>                 
            </mdb-card>
        </div>
        <div class="col-sm-4" style="padding-top:70px">
            <mdb-card>
                <div class="card-header"><h5>Resumen de compra</h5></div>
                 <mdb-card-body>                    
                   <mdb-card-text class="mb-0">

                    <!-- Desglose por grupos - SIEMPRE VISIBLE -->
                    <div class="mb-3">
                      <div class="small fw-bold text-muted mb-2">
                        <i class="fas fa-layer-group me-1"></i>
                        Detalle por Agrupación
                      </div>

                      <!-- Skeleton mientras carga -->
                      <div *ngIf="isCalculatingTotal" class="group-skeleton-container">
                        <div class="group-detail-mini mb-2" *ngFor="let i of [1, 2]">
                          <div class="d-flex justify-content-between align-items-start">
                            <div class="flex-grow-1">
                              <div class="skeleton-line skeleton-title mb-2"></div>
                              <div class="skeleton-line skeleton-subtitle"></div>
                            </div>
                            <div class="text-end">
                              <div class="skeleton-line skeleton-price mb-1"></div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Contenido real cuando termina de cargar -->
                      <div *ngIf="!isCalculatingTotal && resumenPedido.grupos.length > 0">
                        <div *ngFor="let grupo of resumenPedido.grupos" class="group-detail-mini mb-2">
                          <div class="d-flex justify-content-between align-items-start">
                            <div class="flex-grow-1">
                              <div class="fw-bold small">{{ grupo.categoria }}</div>
                              <div class="text-muted" style="font-size: 0.75rem;">
                                {{ grupo.modalidad }} • {{ grupo.cantidad }} unidad{{ grupo.cantidad > 1 ? 'es' : '' }}
                              </div>
                            </div>
                            <div class="text-end">
                              <div class="fw-bold text-danger" style="font-size: 0.9rem;">
                                {{ monedaCarrito }} {{ grupo.subtotal | number : "1.2-2" }}
                              </div>
                              <div *ngIf="grupo.descuento > 0" class="text-success" style="font-size: 0.7rem;">
                                -{{ grupo.porcentajeDescuento }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <hr>

                    <!-- Subtotal sin descuento - Texto siempre visible, valor con skeleton -->
                    <div *ngIf="!isCalculatingTotal && resumenPedido.totalDescuentos > 0" class="row mb-2">
                      <div class="col-7 text-muted small">Subtotal sin descuento:</div>
                      <div class="col-5 text-end small">{{ monedaCarrito }} {{ resumenPedido.subtotalSinDescuento | number : "1.2-2" }}</div>
                    </div>

                    <div *ngIf="isCalculatingTotal" class="row mb-2">
                      <div class="col-7 text-muted small">Subtotal sin descuento:</div>
                      <div class="col-5 text-end">
                        <span class="skeleton-line skeleton-inline-value"></span>
                      </div>
                    </div>

                    <!-- Total de descuentos - Texto siempre visible, valor con skeleton -->
                    <div *ngIf="!isCalculatingTotal && resumenPedido.totalDescuentos > 0" class="row mb-2">
                      <div class="col-7 text-success small fw-bold">
                        <i class="fas fa-tags me-1"></i>
                        Total Descuentos:
                      </div>
                      <div class="col-5 text-end text-success fw-bold small">
                        -{{ monedaCarrito }} {{ resumenPedido.totalDescuentos | number : "1.2-2" }}
                      </div>
                    </div>

                    <div *ngIf="isCalculatingTotal" class="row mb-2">
                      <div class="col-7 text-success small fw-bold">
                        <i class="fas fa-tags me-1"></i>
                        Total Descuentos:
                      </div>
                      <div class="col-5 text-end">
                        <span class="skeleton-line skeleton-inline-value"></span>
                      </div>
                    </div>

                    <!-- Cantidad total - Texto siempre visible, valor con skeleton -->
                    <div class="row mb-2">
                      <div class="col-6 text-muted">Cantidad:</div>
                      <div class="col-6 text-end fw-bold">
                        <span *ngIf="!isCalculatingTotal">{{ cantidadTotal }}</span>
                        <span *ngIf="isCalculatingTotal" class="skeleton-line skeleton-inline-value"></span>
                      </div>
                    </div>

                    <hr>

                    <!-- Total - Texto siempre visible, valor con skeleton -->
                    <div class="row">
                      <div class="col-6 fw-bold">Total:</div>
                      <div class="col-6 text-end fw-bold fs-5 text-danger">
                        <span *ngIf="!isCalculatingTotal">{{ monedaCarrito }} {{ orderCalculateResponse.response.list[0].totalCost }}</span>
                        <span *ngIf="isCalculatingTotal" class="skeleton-line skeleton-total-value"></span>
                      </div>
                    </div>

                    <!-- Mensaje de ahorro -->
                    <div *ngIf="!isCalculatingTotal && resumenPedido.totalDescuentos > 0" class="alert alert-success p-2 mt-3 mb-0" role="alert">
                      <small>
                        <i class="fas fa-check-circle me-1"></i>
                        ¡Estás ahorrando {{ monedaCarrito }} {{ resumenPedido.totalDescuentos | number : "1.2-2" }}!
                      </small>
                    </div>



<!-- 
                     <div class="row">
                       <div class="col-6">
                       Cantidad : 
                       </div>              
                       <div class="col">
                         {{this.cantidadTotal}}
                       </div>
                     </div>
                     
                     <div class="row">
                      <div class="col-6">
                      Descuento Pack : 
                      </div>              
                      <div class="col">
                        PROMPACK1
                      </div>
                    </div>

                     <hr>
                     <div class="row">
                       <div class="col-6">
                         Total:
                       </div>              
                       <div class="col">
                         <span style="font-size: 20px;color: coral;">S/ {{orderCalculateResponse.response.list[0].totalCost}}</span>                                                  
                       </div>
                       <div class="col-sm-12">
                         <p class="textAviso">
                          <br>
                          <br>
                          <br>
                          <br>
                         
                         
                         </p>
                         <ul class="textAviso">

                        </ul>
                       </div>
                     </div>    -->

                     <div class="textAviso mt-4" style="min-height: 100px;">
                      <p class="small text-muted">* Recibirá un correo de confirmación.</p>
                      <ul class="text-muted small">
                        <li>Verifique sus datos antes de continuar.</li>
                      </ul>
                    </div>

                   </mdb-card-text>          
                 </mdb-card-body>
            </mdb-card>            
        </div>
    </div>
</div>  

<div style="display: none;">
  <input type="text" id="txtaddressId" />
  <input type="text" id="txttypeDeliveryId" />  
</div>

<br>
<br>

<!-- Modal de Términos y Condiciones -->
<app-modal-terminos-condiciones
  [isVisible]="mostrarModalTerminos"
  (onClose)="cerrarModalTerminos()"
  (onAccept)="aceptarTerminos()">
</app-modal-terminos-condiciones>



